<div class="flex flex-col items-center gap-5 bg-success-light p-6 text-center">
  <div class="flex size-10 items-center justify-center rounded-full bg-success">
    <mat-icon class="hvs-icon-lg text-white">check</mat-icon>
  </div>
  <span class="text-xl font-semibold text-blue-dark">
    {{ data.title | transloco }}
  </span>
  <span class="text-base font-light text-grey">
    {{ data.description | transloco: data.descriptionParams ?? {} }}
  </span>
  <app-primary-button
    class="w-full"
    [text]="data.buttonText | transloco"
    (buttonClicked)="dialogRef.close()"
  >
  </app-primary-button>
</div>
